import React from 'react';

const TruncateCellRenderer = ({value}) => {
    return (
        <span className="truncate" title={value}>{value}</span>
    );
};

export default TruncateCellRenderer;